import type { OtpChannel } from "../types/api";

/**
 * Channel-aware "your code is on its way" copy, shared by every OTP screen.
 *
 * The screens are the member portal login, partner login 2FA, partner signup
 * phone-verify and org phone-verify. `destination` is a screen-appropriate
 * phone descriptor (e.g. `"***1234"` or a masked number); omit it when the
 * screen doesn't know one, and the SMS copy falls back to "your phone".
 */
export function otpSentMessage(channel: OtpChannel, destination?: string): string {
  if (channel === "call") {
    const at = destination ? ` at ${destination}` : "";
    return `You'll get a phone call${at} — an automated voice will read your 6-digit code twice.`;
  }
  return `We sent a 6-digit code by text to ${destination ?? "your phone"}.`;
}
